/**
 * The news preview opened inside the Nova editor frame (#1013): the editor adds
 * `embed=1` to the signed preview link. The site header and footer are replaced with
 * placeholders there, so the author sees only the article area. Read from the query,
 * so the server render already knows it and the page does not flicker.
 */
export const useEmbeddedPreview = () => {
  const route = useRoute()

  return computed(() => Boolean(route.query.preview) && route.query.embed === '1')
}
